let api = {

    //获取图形码
    randomImage: '/sys/randomImage',
    //TOIKCOS登录页提供申请试用入口
    addApplyForTrial: '/app/platform/addApplyForTrial',
    //查询所有应用系统除去总控
    getAppInfo: "/app/platform/getAppInfo",
    //获取手机验证码
    randomPhoneCode: "/app/platform/randomPhoneCode",
    //用户忘记密码修改密码
    customerForget: "/app/platform/customerForgetPassword",
    //获取当前用户关联的企业列表
    getCustomerCompanyInfo: "/app/platform/getCustomerCompanyInfo",
    //根据企业编号获取当前用户关联的应用列表
    getCustomerAppInfo: "/app/platform/getCustomerAppInfo",
    //登录
    login: "/app/auth/login",
    //退出登录
    logout: "/app/auth/logout",
    //从工作台点击
    validateLogin: "/sys/ext/auth/validateLogin",
    //刷新Token
    getUserPermissionByToken: '/sys/ext/permission/getUserPermissionByToken',
    //手机号登录
    phoneLogin: "/app/auth/phoneLogin",
    //企业微信登录
    qywxLogin: "/app/auth/qywxLogin",
    //修改密码
    updateUsingPUT: "/platform/customer/updatePassword"
}
export default api